import { combineReducers } from '@reduxjs/toolkit'

import { reducer as listNotification } from './listNotification'
import { reducer as countUnreadNoticeReducer } from './countUnreadNotification'

export default combineReducers({
  listNotification,
  countUnreadNoticeReducer,
})
